export default "__VITE_ASSET__CoqjRPdd__"